import { makeStyles, tokens } from "@fluentui/react-components";

export const useSelectableTabListStyles = makeStyles({
  stretchedTabs: {
    flexWrap: "nowrap",
    "> button": {
      flexGrow: 1,
    },
    borderBottom: `1px solid ${tokens.colorBrandBackground2}`,
  },
});
